import { z } from 'zod';
import { appointmentSlot } from '../planning/appointment.js';
import { uuidV7Schema } from '../uuid.js';
/**
 * Le **suivi des appels** d'une demande (M46) — le bloc `cb-calls` du prototype : « Sans réponse »,
 * « Message laissé », et une note libre, chacun daté par le serveur. Une ligne par geste : seule sa
 * note se corrige, et un geste noté par erreur se supprime — son type ne change pas, on le recrée.
 */
export const INQUIRY_CALL_KINDS = ['no_answer', 'message_left', 'note'];
export const inquiryCallKindSchema = z.enum(INQUIRY_CALL_KINDS);
/** Les mots du prototype (`data-call-log`). */
export const INQUIRY_CALL_KIND_LABELS = {
    no_answer: 'Sans réponse',
    message_left: 'Message laissé',
    note: 'Note',
};
export const inquiryCallSchema = z.object({
    id: uuidV7Schema,
    inquiryId: uuidV7Schema,
    kind: inquiryCallKindSchema,
    note: z.string().nullable(),
    /** L'heure du serveur, pas celle du poste : c'est elle qui ordonne les appels. */
    calledAt: z.iso.datetime({ offset: true }),
});
/** Ce que le bureau envoie : le geste, et le texte qui l'accompagne. Une note sans texte se refuse. */
const callNoteSchema = z
    .string()
    .trim()
    .max(500)
    .nullish()
    .transform((note) => (note === '' || note === undefined ? null : note));
export const recordInquiryCallSchema = z
    .object({
    kind: inquiryCallKindSchema,
    note: callNoteSchema,
})
    .refine((call) => call.kind !== 'note' || call.note !== null, {
    message: 'Une note sans texte n’a rien à garder.',
    path: ['note'],
});
/** La correction d'une note : le même texte qu'à l'ajout ; vide, elle s'efface. Le type ne bouge pas. */
export const updateInquiryCallSchema = z.object({ note: callNoteSchema });
/**
 * Un appel dit comme on le colle dans un message — « Message laissé le 12/10 à 10:30 », la note
 * derrière (Sentry BACK-OFFICE-C). L'heure est celle de Paris (`appointmentSlot`).
 */
export function inquiryCallLine(call) {
    const slot = appointmentSlot(call.calledAt);
    const when = slot === null ? '' : ` le ${slot.shortDay} à ${slot.time}`;
    const note = call.note === null ? '' : ` — ${call.note}`;
    return `${INQUIRY_CALL_KIND_LABELS[call.kind]}${when}${note}`;
}
//# sourceMappingURL=call.js.map